
/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('StatisticsCtrl',
    ["$scope","$timeout","$filter","$dialog","CategoryStatView","ServiceStatView","CategoryData","DayData","SiteData","HumanResourceData","HumanResourceStatView",
        "CustomerData","CustomerStatView","CustomerView","SaleCure","GiftItem","LoyaltyCardItem","MenuStatView","ProductCategoryData","ProductCategoryStatView",
        "ProductStatView","CureCategoryStatView","CureCategoryData","CureStatView","LoyaltyCardCategoryStatView","LoyaltyCardCategoryData","LoyaltyCardStatView",
        "DashboardStatView","DashboardData","$spMenu","TypeOfSale","Day","ReportDatasSource","PeriodDatasSource","ReportTemporalAgregateFunctionType","ColorGraph","DateFormator",
        "RootStatCategorie","SimpleReportDataSource","HrRootOccupationRateCategory","PrRootOccupationRateCategory","ReportModelData","ReportView","HrRootCategory",
        "PeriodType","TaxMode","AppData","App","AppAttribute","AppSrv","PeriodStat","TypeOfBooking","StatPeriodType","StoreAppData",
        "SmsCampaign","SmsCampaignSrv","$base64","$http","$sce","$locale", "gettextCatalog","PrimaryDatasType","DashboardSrv","DashboardSchedulerSrv","DashboardScheduler",
        "DashboardSchedulerView","SchedulerType","CompanyImageData","$location","NotificationCampaign", "NotificationCampaignSrv", "MobileDeviceData","MobileDeviceSrv",
        "NbCustormerCategoryStat", "StoreAppCode","moment", "Timers","Constants",
        function($scope,$timeout,$filter,$dialog,CategoryStatView,ServiceStatView,CategoryData,DayData,SiteData,HumanResourceData,HumanResourceStatView,
                 CustomerData,CustomerStatView,CustomerView,SaleCure,GiftItem,LoyaltyCardItem,MenuStatView,ProductCategoryData,ProductCategoryStatView,
                 ProductStatView,CureCategoryStatView,CureCategoryData,CureStatView,LoyaltyCardCategoryStatView,LoyaltyCardCategoryData,LoyaltyCardStatView,
                 DashboardStatView,DashboardData,$spMenu,TypeOfSale,Day,ReportDatasSource,PeriodDatasSource,ReportTemporalAgregateFunctionType,ColorGraph,DateFormator,
                 RootStatCategorie,SimpleReportDataSource,HrRootOccupationRateCategory,PrRootOccupationRateCategory,ReportModelData,ReportView,HrRootCategory,
                 PeriodType,TaxMode,AppData,App,AppAttribute,AppSrv,PeriodStat,TypeOfBooking,StatPeriodType,StoreAppData,
                 SmsCampaign,SmsCampaignSrv,$base64,$http,$sce,$locale, gettextCatalog, PrimaryDatasType, DashboardSrv,DashboardSchedulerSrv,DashboardScheduler,
                 DashboardSchedulerView,SchedulerType,CompanyImageData,$location, NotificationCampaign,NotificationCampaignSrv, MobileDeviceData, MobileDeviceSrv,
                 NbCustormerCategoryStat, StoreAppCode,moment, Timers, Constants) {

            $scope.dd =
            {
                dataLoaded: false,
                loading: true,
                displaySubConf: 1,
                idChart: 1,
                timePeriod: "",
                bookingPriceAverage: 0, // panier moyen

                goBackAvailable: true,
                detailedCategories: false, // first level of zoom in category tree
                finalArray: false, // array displayed when zoom in max used in each view
                finalArrayCaByHr: false, // array displayed when zoom in max in ca view by hr
                finalArrayCaByTypeOfCustomer: false, // array displayed when zoom in max in ca view by type of customer
                finalArrayCustomerDetails: false, // array displayed in customer analyse view when one customer is selected : display ddetails of one customer

                isCollapsed: true,

                // data loaded from models
                hrs: null,
                defaultSite: null,
                days: [],
                categoryRoot: null,
                productCategoryRoot: null,
                cureCategoryRoot: null,
                loyaltyCardCategoryRoot: null,

                now: null,
                periodWatched: [],  // list of days  //TO_DELETE

                periodWatchedLastYear: [],  // list of days
                dateDisplayed: "",
                treeView: [],

                // Ca Values
                categoryStatViewTree: null, // equivalent of categoryRoot with CategoryStatView and ServiceStatView objects for CategoryView and ServiceView
                productCategoryStatViewTree: null,
                cureCategoryStatViewTree: null,
                loyaltyCardCategoryStatViewTree: null,
                selectedCategoryStatView: null,
                listOfCategoryStatViewDisplayed: [], // display only the CategoryStatView which contains booked servicesStatView (for the selector)
                selectedProductCategoryStatView: null,
                listOfProductCategoryStatViewDisplayed: [], // display only the CategoryStatView which contains booked servicesStatView (for the selector)
                selectedCureCategoryStatView: null,
                listOfCureCategoryStatViewDisplayed: [], // display only the CategoryStatView which contains booked servicesStatView (for the selector)
                selectedLoyaltyCardCategoryStatView: null,
                listOfLoyaltyCardCategoryStatViewDisplayed: [], // display only the CategoryStatView which contains booked servicesStatView (for the selector)
                selectedServiceStatView: null,
                listOfServiceStatViewDisplayed: [], // display only the booked ServiceStatView (for the selector)
                listOfBookingServicesDisplayed: [], // display a list of bookings of one service

                selectedTypeOfCustomerByCa: 0, // Ca analyse view / 1 : old ones, 2 : new ones
                selectedListOfCustomersByType: [], // used for Ca and customer view / list for the final array in analyse client

                selectedHrByCa: null,  // HumanResource
                listOfBookingsOfSelectedHr: [], // used for CA and occupationRate
                listOfSaleServicesOfSelectedHr: [], // used for CA and occupationRate
                sumOfSaleServicesOfSelectedHr: 0,
                listOfSaleProductsOfSelectedHr: [],         // used for CA and occupationRate
                sumOfSaleProductsOfSelectedHr: 0,
                listOfSaleCuresOfSelectedHr: [],         // used for CA and occupationRate
                sumOfSaleCuresOfSelectedHr: 0,
                listOfLoyaltyCardItemsOfSelectedHr: [],         // used for CA and occupationRate
                sumOfLoyaltyCardItemsOfSelectedHr: 0,
                listOfHrDisplayed: [], // display only the Hr which have a rate > 0% <=> at least one bookingService (for the selector)

                listOfCustomerStatView: [], // the list of the customerStatView existing in the periodWatched
                selectedTypeOfCustomer: 0, // Customer analyse view / 1 : old ones, 2 : new ones

                globalData : {ca:0,hrCa:0},
                serviceData : {ca:0},
                productData : {ca:0},
                cureData : {ca:0},
                loyaltyCardData : {ca:0},
                giftItemData : {ca:0},
                // selectedCustomerStatView and selectedCustomerView used to see details of one customer in analyse customer view zoom in
                selectedCustomerStatView: null,
                selectedCustomerView: null,  // useful to get the came / not came attributes

                // occupation rate
                hrStatViews: [],
                selectedHrByRate: null,  // HumanResource
                hrWithGift: true,

                // menu in anayse views
                rateDisplayed: 1,
                caDisplayed: 1,
                caDisplayedSub: null,
                customerDisplayed: 1,
                datePickerDisplayed: false,
                rootMenuStatView: null,
                globalMenuDisplayed : 1,
                menuMobile : true,
                cMenuStatView: null,
                dashboardsView : [],
                selectedDashboardView : null,
                selectedDashboardSchedulerView : null,
                allReportsView : [],
                freeReportsView : [],
                advancedReportsView : [],
                reportCategoriesView: [{
                    label: "Rapports recommandés par " + $scope.ad.brand.label,
                    imgUrl: $scope.ad.brand.images.logoWhite,
                    reportsCodes: ["ca", "sale-by-hr", "giftItem"],
                    reportsView: []
                },{
                    label: "Ventilation du chiffre d'affaires",
                    imgUrl: "/img/statistics/ca.svg",
                    reportsCodes: ["ca", "nb-sales", "not-honored-booking", "gain-by-minute", "products-ca", "daily-average-nb-sales","sales-by-visit"],
                    reportsView: []
                }, {
                    label: "Performances commerciales",
                    imgUrl: "/img/statistics/commerciale.svg",
                    reportsCodes: ["average-cart", "average-cart-by-gender", "average-cart-gift","booking-in-line", "fidelity-collaborator-rate"],
                    reportsView: []
                }, {
                    label: "Optimisation des plannings",
                    imgUrl: "/img/statistics/planning.svg",
                    reportsCodes: ["hr-occupation-rate", "pr-occupation-rate", "not-honored-booking", "custormer-come", "gain-by-minute","working-time"],
                    reportsView: []
                }, {
                    label: "Performances des collaborateurs",
                    imgUrl: "/img/statistics/collaborateur.svg",
                    reportsCodes: ["sale-by-hr", "visits-by-collab", "nb-sales-by-personnal", "fidelity-collaborator-rate", "hr-occupation-rate", "working-time", "daily-average-nb-visits-by-personnal"],
                    reportsView: []
                }, { label: "Suivi des clients",
                    imgUrl: "/img/statistics/client.svg",
                    reportsCodes: ["old-and-new-customer", "nb-customers", "new-customer", "old-customer", "not-honored-booking", "custormer-come", "penetration-rate", "fidelity-rate"],
                    reportsView: []
                }],
                reportTextFilter : "",
                statMenu : true,
                reportDataSources : new Array(),
                graphColors : ColorGraph.colors,
                displayUnsavedMessage : false,
                currentPeriod : null,
                pastPeriod : null,
                periodType : PeriodType.MONTH,
                beginMoment : null,
                endMoment : null,
                taxMode : TaxMode.HT,
                additionalFilters : [],
                hideUsedReport : false,//TO MANAGE IT IN FUTURE VERSION
                pageDisplayed : {
                    type : null, // null / "addReports","business","helpCenter","commnunicate","dashboardMng", "detail"
                    selectedReportView :null
                },
                businessPage : null,
                helpCenterArticle : null,
                businessNotHonoredData : null,
                notHonoredBookingProjectionData : new Array(),
                smsRecallCostProjectionData : new Array(),
                caIncreaseProjectionData : new Array(),
                businessNotHonoredParameters : {
                    nbMonth: 6,
                    maxiRatio: 0.75,
                    miniRatio: 0.2,
                    smsPrice : null,
                   /* colorsBenefits : ['#C5FF6C','#B4FFC7'],*/
                    colorsBenefits : ['#B4FFC7', '#B4FFC7'],
                    colorsDepenses : ['#FFCAC7']
                },
                recallActivatedMessageDisplayed : false,
                recallActivatedSmsCampaignMessageDisplayed : false,
                recallActivatedNotificationCampaignMessageDisplayed : false,
                reloadDailyPrecalculatedDatas : false,
                sendDashboardOkDisplayed : false,
                sendDashboardPeriodicOkDisplayed : false,
                StatPeriodType : StatPeriodType,
                PrimaryDatasType : PrimaryDatasType,
                shareInfo : {
                    type : SchedulerType.SINGLE,
                    surname : null,
                    object : null,
                    message : null,
                    emailList : [],
                    displayEmptyEmail : false,
                    displayEmptyObject : false,
                    displayEmptySurname : false,
                    periodic : false
                },
                SchedulerType : SchedulerType,
                dashboardOverview : false,
                NbCustormerCategoryStat : NbCustormerCategoryStat
            };

            let timers = [];

            $scope.fetchStatistics = function() {
                $scope.dd.loading = true;
                return DashboardSrv.query(() => {
                    $scope.loadDashboards();
                    $scope.loadReportsView();

                    $scope.loadBusinessNotHonoredData();
                    $scope.loadNotHonoredBookingProjectionDataGraphs();
                    $scope.dd.loading = false;
                }, () => {
                    $scope.dd.loading = false;
                });
            };

            $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
                if (newValue) {
                    $scope.redirectToPlanningIfStatisticsDisabled();
                    if (!$scope.ad.managerMode) {
                        $scope.goToDomain("planningPos", "dashboard");
                    }

                    $scope.dd.loading = false;
                    $scope.dd.beginMoment = new moment();
                    $scope.dd.endMoment = new moment();

                    $scope.dd.categoryRoot = CategoryData.categoryRoot;
                    $scope.dd.productCategoryRoot = ProductCategoryData.categoryRoot;
                    $scope.dd.cureCategoryRoot = CureCategoryData.categoryRoot;
                    $scope.dd.loyaltyCardCategoryRoot = LoyaltyCardCategoryData.categoryRoot;

                    CategoryData.categoryRoot.label = TypeOfSale.SERVICE.label;
                    ProductCategoryData.categoryRoot.label = TypeOfSale.PRODUCT.label;
                    CureCategoryData.categoryRoot.label = TypeOfSale.CURE.label;
                    LoyaltyCardCategoryData.categoryRoot.label = TypeOfSale.LOYALTY.label;

                    $scope.dd.businessNotHonoredParameters.smsPrice = $scope.ad.view.companyView.getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_SMS_REMINDER_APP_CODE).price;//StoreAppData.getByCode("smsCampaign").price;

                    $scope.reloadDailyPrecalculatedDatas = true;

                    $scope.loadStatisticAppParameter("taxMode");

                    const dashboardList = DashboardData.getDashboardList();
                    if (dashboardList && dashboardList.length === 0) {
                        $scope.fetchStatistics();
                    } else {
                        $scope.loadDashboards();
                        $scope.loadReportsView();
                        $scope.loadBusinessNotHonoredData();
                        $scope.loadNotHonoredBookingProjectionDataGraphs();
                    }

                    $scope.dd.shareInfo.emailList.push({ text: $scope.ad.loggedUser.email });
                    //$scope.loadLogo();
                }
            });

            //Manage windows width resize
            var width = $(window).width();
            var doit;
            $(window).resize(function(){
                if($(this).width() != width){
                    width = $(this).width();
                    clearTimeout(doit);
                    $scope.dd.loading =true;
                    $scope.safeApply();
                    doit = setTimeout($scope.onWindowResizeEnd, 250);
                }
            });
            $scope.onWindowResizeEnd = function()
            {
                $scope.dd.loading =false;
                $scope.safeApply();
            };

            $scope.safeApply = function(fn) {
                if ($scope.$root)
                {
                    var phase = $scope.$root.$$phase;
                    if(phase == '$apply' || phase == '$digest') {
                        if(fn && (typeof(fn) === 'function')) {
                            fn();
                        }
                    } else {
                        $scope.$apply(fn);
                    }
                }
                else
                    $scope.$apply(fn);

            };

            $scope.getReportView = function(reportId){
                var reportsView = null;
                for(var i = 0; i < $scope.dd.allReportsView.length; i++){
                    if($scope.dd.allReportsView[i].id == reportId){
                        reportsView = $scope.dd.allReportsView[i];
                        break;
                    }
                }
                return reportsView;
            }

            $scope.getVisibleReports = function(globalMenuDisplayed)
            {
                var visibleReports = null;
                if(globalMenuDisplayed == 1){
                    visibleReports = $scope.dd.selectedDashboardView.reportsView;
                }
                else if(globalMenuDisplayed == 2){
                    visibleReports = $scope.dd.freeReportsView;
                }
                else if(globalMenuDisplayed == 3){
                    visibleReports = $scope.dd.advancedReportsView;
                }
                return visibleReports;
            }

            $scope.getUnVisibleReports = function(globalMenuDisplayed)
            {
                var unVisibleReports = null;
                if(globalMenuDisplayed == 1){
                    unVisibleReports = $scope.dd.freeReportsView.concat($scope.dd.advancedReportsView).concat($scope.dd.allReportsView);
                }
                else if(globalMenuDisplayed == 2){
                    unVisibleReports = $scope.dd.selectedDashboardView.reportsView.concat($scope.dd.advancedReportsView).concat($scope.dd.allReportsView);
                }
                else if(globalMenuDisplayed == 3){
                    unVisibleReports = $scope.dd.selectedDashboardView.reportsView.concat($scope.dd.freeReportsView).concat($scope.dd.allReportsView);
                }
                for(var i = 0 ; i < $scope.dd.dashboardsView.length; i ++){
                    if($scope.dd.dashboardsView[i] != $scope.dd.selectedDashboardView){
                        unVisibleReports = unVisibleReports.concat($scope.dd.dashboardsView[i].reportsView);
                    }
                }
                return unVisibleReports;
            }


            $scope.nextReportPromises = [];
            $scope.unvisiblePromise = null;

            $scope.reloadReportsDataSource = function()
            {
                $timeout.cancel($scope.unvisiblePromise);
                for(var i = 0; i < $scope.nextReportPromises.length; i++){
                    $timeout.cancel($scope.nextReportPromises[i]);
                }
                $scope.nextReportPromises = [];

                var numLoad = Math.floor(Math.random() * 100);

                var globalMenuDisplayed = $scope.dd.globalMenuDisplayed;
                //reload visible reports
                $scope.reloadReportsDataSourceOf($scope.getVisibleReports(globalMenuDisplayed), numLoad);

                $scope.unvisiblePromise = $timeout(function () {
                    $scope.reloadReportsDataSourceOf($scope.getUnVisibleReports(globalMenuDisplayed), numLoad);
                },100);
            };

            $scope.reloadReportsDataSourceOf = function(reportsView, numLoad)
            {
                for(var i = 0 ; i <  reportsView.length; i++){
                    var reportView = reportsView[i];
                    reportsView[i].loading = true;
                }

                $scope.loadAndDisplayReportView(reportsView, 0, numLoad);
            };

            $scope.loadAndDisplayReportView = function(reportsView,index, numLoad){
                if (reportsView && index < reportsView.length) {

                    if (reportsView[index].eltsReport && reportsView[index].getDataSource() && reportsView[index].getDataSource().loadPeriod) {
                        //reportsView[index].getDataSource().loadPeriod($scope.dd.periodWatched[0].getMomentDate(), $scope.dd.timePeriod);
                        reportsView[index].getDataSource().loadPeriod($scope.dd.currentPeriod, $scope.dd.pastPeriod, $scope.dd.taxMode, $scope.dd.additionalFilters);
                    }

                    reportsView[index].loading = false;
                    $scope.nextReportPromises.push($timeout(function () {
                        $scope.loadAndDisplayReportView(reportsView,index+1, numLoad);
                    },100));
                }
            };

            $scope.loadDashboards = function() {
                $scope.dd.dashboardsView = [];
                var indexFirstDashboard = null;

                for(var i = 0; i < DashboardData.getDashboardList().length; i++){
                    var newDashboard = new DashboardStatView(DashboardData.getDashboardList()[i], i, $scope.isSolutionActivated,$scope.ad.view.companyView.startModelId);
                    $scope.dd.dashboardsView.push(newDashboard);
                    if(!indexFirstDashboard && !newDashboard.isFlexy){
                        indexFirstDashboard = i;
                    }
                }
                if ($scope.dd.dashboardsView.length!=0) {
                    $scope.loadStatisticAppParameter("selectedDashboardId");

                    if(!$scope.dd.selectedDashboardView && $scope.dd.dashboardsView.length > 0){
                        $scope.dd.selectedDashboardView = $scope.dd.dashboardsView[0];
                    }
                }
                else{
                    var newDashboard = new DashboardStatView();
                    $scope.dd.dashboardsView.push(newDashboard);
                    $scope.dd.selectedDashboardView = newDashboard;
                }
            };

            $scope.isSolutionActivated = function(reportModelId){
                var isSolutionActivated = false;
                if(reportModelId == "not-honored-booking"){
                    var smsReminder = $scope.ad.view.companyView.getSubscriptionViewByStoreAppViewCode('smsReminder');
                    if(smsReminder) {
                        isSolutionActivated = smsReminder.isActive;
                    }
                }
                return isSolutionActivated;
            }

            $scope.loadReportsView = function(){
                var reportsModel = ReportModelData.getActiveList();
                $scope.dd.freeReportsView = [];
                $scope.dd.advancedReportsView = [];
                $scope.dd.allReportsView = [];
                for (var i=0;i<reportsModel.length;i++)
                {
                    var reportView = new ReportView(reportsModel[i], null, $scope.dd.taxMode, $scope.isSolutionActivated,$scope.ad.view.companyView.startModelId);

                    $scope.dd.allReportsView.push(reportView);
                    if (reportsModel[i].advanced)
                        $scope.dd.advancedReportsView.push(reportView);
                    else
                        $scope.dd.freeReportsView.push(reportView);
                }
                $scope.loadReportCategoriesView($scope.dd.allReportsView);
            };
            $scope.loadReportCategoriesView = function(reportsView){

                if (reportsView)
                    $scope.dd.reportCategoriesView.forEach( (reportCategory) => {
                        reportCategory.reportsView = [];
                        reportsView.forEach( (reportView) => {
                            if (reportCategory.reportsCodes.indexOf(reportView.id)!=-1)
                                reportCategory.reportsView.push(reportView);
                        });
                    });
            }

            $scope.displayModifyButton = function(){
                if($scope.dd.selectedDashboardView.isFlexy) {
                    $scope.openEditFlexyDashboardViewConfirmDialog();

                }else{
                    $scope.dd.selectedDashboardView.editing = true;
                }
            };


            $scope.displayReportsAddView = function(){
                if ($scope.dd.selectedDashboardView) {
                    $scope.dd.reportsForSearchLoad = false;
                    $scope.dd.reportTextFilter = "";
                    $scope.setPageDisplayed("addReports");
                    $scope.dd.selectedDashboardView.editing = true;
                    $scope.dd.selectedDashboardView.activeCategoryReportView = null;
                    $scope.dd.selectedDashboardView.activeReportView = null;
                    $scope.displayReportLoader($scope.dd.allReportsView);
                    const timer = $timeout(function() {
                        $scope.dd.reportsForSearchLoad = true;
                    },200)
                    timers.push(timer);
                }
            };
            $scope.setPageDisplayed = function(type, reportView)
            {
                //set to null if ask for it or already active
                if (type=== undefined || !type || ($scope.dd.pageDisplayed && $scope.dd.pageDisplayed.type && $scope.dd.pageDisplayed.type==type && $scope.dd.pageDisplayed.selectedReportView == reportView))
                {
                    $scope.dd.pageDisplayed.type = null;
                    $scope.dd.pageDisplayed.selectedReportView = null;
                }
                else {
                    $scope.dd.pageDisplayed.type = type;
                    if (reportView !== undefined)
                        $scope.dd.pageDisplayed.selectedReportView = reportView;
                }
            }


            $scope.displayReportsBusinessView = function(reportView,businessPage){
                $scope.setPageDisplayed("business",reportView);
                $scope.businessPage = businessPage;//TODO REMOVE AND MANAGE ONLY SELECTED REPORTVIEW
            };

            $scope.displayReportsCommunicateView = function(reportView){
                $scope.setPageDisplayed("communicate",reportView);
            };

            $scope.displayReportsDetailView = function(reportView){
                $scope.setPageDisplayed("detail",reportView);
            };

            $scope.displayReportsShareView = function(reportView){
                $scope.setPageDisplayed("share",reportView);
            };

            $scope.displayReportsSchedulerListView = function(reportView){
                $scope.setPageDisplayed("schedulerList",reportView);
            };

            $scope.trustAsHtml = function(string) {
                return $sce.trustAsHtml(string);
            };

            $scope.displayReportLoader = function(reportsView){
                if (reportsView)
                {
                    for (var i=0;i< reportsView.length;i++)
                        reportsView[i].loading = true;
                    $scope.displayReport(reportsView,0);
                }
            };

            $scope.displayReport = function(reportsView,index){
                if (reportsView && index<reportsView.length) {
                    reportsView[index].loading = false;
                   const timer = $timeout(function () {
                        $scope.displayReport(reportsView,index+1);
                    },100);
                    timers.push(timer);
                }
            };

            $scope.createNewDashboard = function() {
                var newDashboard = new DashboardStatView();
                $scope.dd.dashboardsView.push(newDashboard);
                newDashboard.editing = true;
                $scope.setPageDisplayed();
                $scope.dd.selectedDashboardView = newDashboard;
                $scope.displayReportsAddView();

            };


            $scope.cloneSelectedDashboard = function(){
                var defaultTitle = gettextCatalog.getString("Mon tableau de bord");
                var dashboardToClone = $scope.dd.selectedDashboardView;
                $scope.createNewDashboard();

                for(var i = 0; i < dashboardToClone.reportsView.length; i++){
                    $scope.dd.selectedDashboardView.addReport(dashboardToClone.reportsView[i]);

                }
                $scope.dd.selectedDashboardView.title = defaultTitle;
                $scope.saveSelectedDashboardView();
            }

            $scope.saveSelectedDashboardView = function (){
                var dashboardView = $scope.dd.selectedDashboardView;
                dashboardView.updateModel(function() {
                    if(dashboardView.dashboardModel) {
                        $scope.saveAppParameter("selectedDashboardId", dashboardView.dashboardModel.id);
                    }
                });
                $scope.dd.displayUnsavedMessage = false;

                $scope.dd.selectedDashboardView.editing = false;
                $scope.displayChangeMsg = false;
                if($scope.dd.dashboardsView.indexOf($scope.dd.selectedDashboardView) == -1){
                    $scope.dd.dashboardsView.push($scope.dd.selectedDashboardView);
                }
            };

            $scope.openDeletedDashboardViewConfirmDialog  = function()
            {
                if ($scope.dd.selectedDashboardView)
                {
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl:  '/partials/global/removeConfirm.html',
                        controller: 'DialogCtrl' ,
                        resolve: {
                            dialogsModel: function() {
                                var tableModel = [] ;
                                tableModel["label"] = $scope.dd.selectedDashboardView.titre;
                                return tableModel;
                            }}};

                    var d = $dialog.dialog(opts);
                    d.open().then(function(result){
                        if (result)
                            $scope.removeSelectedDashboardView();
                    });
                }
            };

            $scope.openEditFlexyDashboardViewConfirmDialog  = function()
            {
                if ($scope.dd.selectedDashboardView)
                {
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl:  '/partials/global/editFlexyDashboardConfirm.html',
                        controller: 'DialogCtrl' ,
                        resolve: {
                            dialogsModel: function() {
                                var tableModel = [] ;
                                tableModel["label"] = $scope.dd.selectedDashboardView.titre;
                                return tableModel;
                            }}};

                    var d = $dialog.dialog(opts);
                    d.open().then(function(result){
                        if (result)
                            $scope.cloneSelectedDashboard();
                        //TODO CREATE NEW DASHBOARD FROM FLEXY TEMPLATE
                    });
                }
            };

            $scope.loadDashboardView = function(dashboardView) {
                $scope.dd.selectedDashboardView = dashboardView;
                if(dashboardView.dashboardModel) {
                    $scope.saveAppParameter("selectedDashboardId", dashboardView.dashboardModel.id);
                }
            }

            $scope.removeSelectedDashboardView = function()
            {
                if ($scope.dd.selectedDashboardView)
                {
                    $scope.dd.selectedDashboardView.removeModel();
                    var index = $scope.dd.dashboardsView.indexOf($scope.dd.selectedDashboardView);
                    if (index!=-1)
                    {
                        $scope.dd.dashboardsView.splice(index,1);
                    }
                }
                if($scope.dd.dashboardsView.length == 0){
                    $scope.createNewDashboard();
                }
                else{
                    $scope.dd.selectedDashboardView = $scope.dd.dashboardsView[0];
                }
            };

            $scope.cancelEditedDashboard = function()
            {
                if ($scope.dd.selectedDashboardView)
                {
                    $scope.dd.displayUnsavedMessage = false;
                    $scope.dd.selectedDashboardView.reloadModel($scope.isSolutionActivated,$scope.ad.view.companyView.startModelId);
                    $scope.displayChangeMsg = false;
                    $scope.dd.selectedDashboardView.editing = false;
                    $scope.reloadReportsDataSource();
                }
            };

            $scope.displayMenu  = function () {
                $scope.dd.statMenu = true;

                    $spMenu.show();
                const timer = $timeout(function() {
                    window.dispatchEvent(new Event('resize'));
                },500);
                timers.push(timer);
            };

            $scope.hideMenu  = function () {
                $scope.dd.statMenu = false;

                $spMenu.hide();
                const timer = $timeout(function() {
                    window.dispatchEvent(new Event('resize'));
                },500);
                timers.push(timer);
            }

            $scope.onTitleDashboardClick = function(){
                if(!$scope.dd.selectedDashboardView.isFlexy) {
                   $scope.dd.selectedDashboardView.editing = true
                }
            }

            $scope.onDashboardGestionClick = function(){
                if($scope.dd.selectedDashboardView.isChanged() && $scope.dd.selectedDashboardView.dashboardModel != null && $scope.dd.selectedDashboardView.dashboardIndex != null){
                    $scope.dd.displayUnsavedMessage = true;
                }
                else {
                    $scope.setPageDisplayed("dashboardMng");
                }
            }

            $scope.onPeriodChanged = function(newCurrentPeriod, newPastPeriod){
                if(!$scope.dd.currentPeriod || !$scope.dd.currentPeriod.isSame(newCurrentPeriod)) {
                    $scope.dd.currentPeriod = newCurrentPeriod;
                    $scope.dd.pastPeriod = newPastPeriod;

                    $scope.dd.periodType = $scope.dd.currentPeriod.periodType;
                    $scope.dd.beginMoment = $scope.dd.currentPeriod.beginMomentDay;
                    $scope.dd.endMoment = $scope.dd.currentPeriod.endMomentDay;
                    $scope.reloadReportsDataSource()
                }
            }

            $scope.onTaxModeChange = function(newTaxMode){
                $scope.dd.taxMode = newTaxMode;
                $scope.saveAppParameter("taxMode", $scope.dd.taxMode.id);

                $scope.reloadReportsDataSource();
            }

            $scope.loadStatisticAppParameter = function(parameterName)
            {
                if(AppData.getAppList().length > 0)
                {
                    var statisticApp = AppData.getAppByCode("statistic");
                    if(statisticApp !== null)
                    {
                        if (parameterName == "taxMode" && statisticApp.getAppAttribute(parameterName) !== null)
                            $scope.dd.taxMode = TaxMode.getTaxModeById(statisticApp.getAppAttribute(parameterName).value );

                        if (parameterName == "selectedDashboardId"){
                            $scope.dd.selectedDashboardView = null;
                            if(statisticApp.getAppAttribute(parameterName) !== null) {
                                for (var i = 0; i < $scope.dd.dashboardsView.length; i++) {
                                    if ($scope.dd.dashboardsView[i].dashboardModel && $scope.dd.dashboardsView[i].dashboardModel.id && $scope.dd.dashboardsView[i].dashboardModel.id == statisticApp.getAppAttribute(parameterName).value) {
                                        $scope.dd.selectedDashboardView = $scope.dd.dashboardsView[i];
                                    }
                                }
                            }
                            if (!$scope.dd.selectedDashboardView && $scope.dd.dashboardsView.length>0)
                                $scope.dd.selectedDashboardView = $scope.dd.dashboardsView[0];
                        }
                    }
                }
            };

            $scope.saveAppParameter = function(parameterName, parameterValue)
            {
                var statisticApp = AppData.getAppByCode("statistic");

                if(statisticApp !== null)
                {
                    //agenda app exists
                    var appAttribute = statisticApp.getAppAttribute(parameterName);
                    if (appAttribute)
                        statisticApp.setAppAttribute(parameterName, parameterValue);
                    else
                        statisticApp.addAppAttribute(new AppAttribute(parameterName, parameterValue));

                    AppSrv.save(statisticApp);
                }
                else
                {
                    // if statistic app doesn't exist and/or values are not the same
                    statisticApp = new App();
                    statisticApp.setCode("statistic");
                    statisticApp.addAppAttribute(new AppAttribute(parameterName, parameterValue));

                    AppSrv.save(statisticApp);
                }
            };

            $scope.loadBusinessNotHonoredData = function()
            {
                var nbMonth = 6,
                    beginMoment =  new moment().startOf('month').add(nbMonth * (-1), 'month'),
                    endMoment =  new moment().startOf('month').add(-1, 'day'),
                    notHonoredBookingPrice = 0,
                    nbBooking = 0;

                 var last6monthsPeriod = new PeriodStat(StatPeriodType.PAST, beginMoment, endMoment, PeriodType.CUSTOMED);

                for (var i = 0; i < last6monthsPeriod.arrayOfDays.length; i++) {
                    var day = last6monthsPeriod.arrayOfDays[i];

                    if (day && day.isAStatisticDay()) {
                        notHonoredBookingPrice += day.getBookingsCAOfBookingObject([TypeOfBooking.NOT_COME], last6monthsPeriod.arrayOfDays[0], $scope.taxMode);
                        nbBooking += day.getNbBookingsOfBookingObject([TypeOfBooking.COME_AND_NOT_COME], last6monthsPeriod.arrayOfDays[0], $scope.taxMode);
                    }
                }
                $scope.dd.businessNotHonoredData =  {
                    "averageOfNotHonoredBooking" : (notHonoredBookingPrice / nbMonth),
                    "averageNbBooking" : (nbBooking / nbMonth)
                }
            };

            $scope.loadNotHonoredBookingProjectionDataGraphs = function() {
                var monthlyDatasFirstRow = new Array(),
                    monthlyDatas = new Array(),
                    currentMomentDay =  new moment().startOf('month'),
                    endMoment =  new moment().startOf('month').add($scope.dd.businessNotHonoredParameters.nbMonth, 'month'),
                    monthlyAverageOfNotHonoredBooking = $scope.dd.businessNotHonoredData.averageOfNotHonoredBooking,
                    monthlyAverageNbBooking = $scope.dd.businessNotHonoredData.averageNbBooking;

                monthlyDatasFirstRow.push({id: 'jour', label: 'jour', type: 'date'});
                //monthlyDatasFirstRow.push("Economie minimum");
                monthlyDatasFirstRow.push("Economie minimum");
                $scope.dd.notHonoredBookingProjectionData.push(monthlyDatasFirstRow);

                monthlyDatasFirstRow = new Array()
                monthlyDatasFirstRow.push({id: 'jour', label: 'jour', type: 'date'});
                monthlyDatasFirstRow.push("Coût des rappels de rendez-vous par sms");
                $scope.dd.smsRecallCostProjectionData.push(monthlyDatasFirstRow);

                monthlyDatasFirstRow = new Array()
                monthlyDatasFirstRow.push({id: 'jour', label: 'jour', type: 'date'});
                //monthlyDatasFirstRow.push("Augmentation du CA minimum");
                monthlyDatasFirstRow.push("Augmentation du CA maximum");
                $scope.dd.caIncreaseProjectionData.push(monthlyDatasFirstRow);

                while(endMoment.diff(currentMomentDay) >= 0){
                    var monthArray = new Array();
                    monthArray.push(currentMomentDay.toDate());
                    //monthArray.push(monthlyAverageOfNotHonoredBooking * $scope.dd.businessNotHonoredParameters.miniRatio);
                    monthArray.push(monthlyAverageOfNotHonoredBooking * $scope.dd.businessNotHonoredParameters.maxiRatio);
                    $scope.dd.notHonoredBookingProjectionData.push(monthArray);

                    var monthArray = new Array();
                    monthArray.push(currentMomentDay.toDate());
                    monthArray.push(monthlyAverageNbBooking * $scope.dd.businessNotHonoredParameters.smsPrice);
                    $scope.dd.smsRecallCostProjectionData.push(monthArray);


                    var monthArray = new Array();
                    monthArray.push(currentMomentDay.toDate());
                    //monthArray.push(monthlyAverageOfNotHonoredBooking * $scope.dd.businessNotHonoredParameters.miniRatio - monthlyAverageNbBooking * $scope.dd.businessNotHonoredParameters.smsPrice);
                    monthArray.push(monthlyAverageOfNotHonoredBooking * $scope.dd.businessNotHonoredParameters.maxiRatio - monthlyAverageNbBooking * $scope.dd.businessNotHonoredParameters.smsPrice);
                    $scope.dd.caIncreaseProjectionData.push(monthArray);

                    currentMomentDay.add(1, 'month');
                }
            };

            $scope.activateSmsCampaign = function (){
                var smsReminder = $scope.ad.view.companyView.getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_SMS_REMINDER_APP_CODE);
                if(smsReminder) {
                    smsReminder.isActive = true;
                    $scope.ad.view.companyView.updateModelSubscriptions();
                }
                $scope.dd.recallActivatedMessageDisplayed = true;

            };

            $scope.createNotification = function (label,customerList){
                if (label && customerList && customerList.length>0) {
                    var notifCampaign = new NotificationCampaign();
                    notifCampaign.label = label;
                    customerList.forEach( (element) => {
                        var mobileDevices = MobileDeviceData.getListByCustomerId(element.id)
                        if(mobileDevices && mobileDevices.length > 0)
                            mobileDevices.forEach( (mobile) => {
                                notifCampaign.mobiles.push(mobile)
                            });
                    });
                    if (notifCampaign.mobiles.length==0)
                    {
                        var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl: '/partials/global/infoDialog.html',
                            controller: 'DialogCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    var tableModel = [];
                                    var label = gettextCatalog.getString("La campagne de notifications n'a pas été créée, car aucun client ne possède l'application mobile.");
                                    tableModel["label"] = label;
                                    return tableModel;
                                }
                            }
                        };
                        $dialog.dialog(opts).open();
                    }
                    else { // SUCCESS
                        notifCampaign.status = "createdFromReport";
                        notifCampaign.type = "campaign";
                        NotificationCampaignSrv.save(notifCampaign);
                        $scope.dd.recallActivatedNotificationCampaignMessageDisplayed = true;
                        $scope.setPageDisplayed();
                        const timer = $timeout(function () {
                            $scope.dd.recallActivatedNotificationCampaignMessageDisplayed = false;
                        }, 20000);
                        timers.push(timer);
                    }
                }
                else {
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/infoDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                var label = gettextCatalog.getString("La campagne de notifications n'a pas été créée, car il n'y a aucun client dans le tableau.");
                                tableModel["label"] = label;
                                return tableModel;
                            }
                        }
                    };
                    $dialog.dialog(opts).open();
                }
            }
            $scope.checkForCreateNotification = function (label,customerList){
                if (!$scope.ad.addons.sub.nativeAppAccess) {
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/infoDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                var label = gettextCatalog.getString("La campagne de notifications n'est pas disponible sans application mobile.");
                                tableModel["label"] = label;
                                return tableModel;
                            }
                        }
                    };
                    $dialog.dialog(opts).open();
                }
                else{
                    if(MobileDeviceData.getActiveList().length == 0){
                        MobileDeviceSrv.query(
                            function(data) {
                                $scope.createNotification(label,customerList);
                            },
                            function(data) {}
                        );
                    }
                    else{
                        $scope.createNotification(label,customerList);
                    }
                }
            };

            $scope.createSmsCampaign = function (label,customerList){
                var smsCampaign = $scope.ad.view.companyView.getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_SMS_CAMPAIGN_APP_CODE);
                var msgSmsCampain = gettextCatalog.getString("L'option campagne de sms n'est pas activée");
                if (!smsCampaign || !smsCampaign.isActive) {
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/infoDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["label"] = msgSmsCampain+".";
                                return tableModel;
                            }
                        }
                    };
                    $dialog.dialog(opts).open();
                }
                else
                    if (label && customerList && customerList.length>0) {
                        var smsCampaign = new SmsCampaign();
                        smsCampaign.initUsingDefaults();
                        smsCampaign.label = label; // TODO ADD PATH TO LABEL
                        customerList.forEach( (element) => {
                            if (element.phone && element.phone!="")
                                smsCampaign.customers.push(element)
                        });
                        if (smsCampaign.customers.length==0)
                        {
                            var msgSmsCampainNOk = gettextCatalog.getString("La campagne de sms n'a pas été créée, car aucun client qui possède un téléphone mobile");
                            var opts = {
                                backdrop: true,
                                keyboard: true,
                                backdropClick: false,
                                templateUrl: '/partials/global/infoDialog.html',
                                controller: 'DialogCtrl',
                                resolve: {
                                    dialogsModel: function () {
                                        var tableModel = [];
                                        tableModel["label"] = msgSmsCampainNOk+".";
                                        return tableModel;
                                    }
                                }
                            };
                            $dialog.dialog(opts).open();
                        }
                        else { // SUCCESS
                            smsCampaign.status = "createdFromReport";
                            SmsCampaignSrv.save(smsCampaign);
                            $scope.dd.recallActivatedSmsCampaignMessageDisplayed = true;
                            $scope.setPageDisplayed();
                            const timer = $timeout(function () {
                                $scope.dd.recallActivatedSmsCampaignMessageDisplayed = false;
                            }, 20000);
                            timers.push(timer);
                        }
                    }
                    else {
                        var msgSmsCampainNOK = gettextCatalog.getString("La campagne de sms n'a pas été créée car il n'y a aucun client dans le tableau");

                        var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl: '/partials/global/infoDialog.html',
                            controller: 'DialogCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    var tableModel = [];

                                    tableModel["label"] = msgSmsCampainNOK+".";
                                    return tableModel;
                                }
                            }
                        };
                        $dialog.dialog(opts).open();
                    }
            };

            $scope.exportExcel = function(objet, idTable, title){
                return ExcellentExport.excel(objet, idTable, title);
            };

            $scope.exportCsv = function(objet, idTable){
                return ExcellentExport.csv(objet, idTable);
            };

            $scope.succesSendEmail = function(){
                $scope.dd.sendDashboardOkDisplayed = true;
                $scope.setPageDisplayed();
                const timer = $timeout(function () {
                    $scope.dd.sendDashboardOkDisplayed = false;
                }, 20000);
                timers.push(timer);

                $scope.setPageDisplayed();
            };

            $scope.succesSendPeriodicEmail = function(){
                $scope.dd.sendDashboardPeriodicOkDisplayed = true;
                $scope.setPageDisplayed();
                const timer = $timeout(function () {
                    $scope.dd.sendDashboardPeriodicOkDisplayed = false;
                }, 20000);
                timers.push(timer);

                $scope.setPageDisplayed();
            };

            $scope.failureSendEmail = function(){
                alert("echec");
            };

            $scope.getSendMail = function(){
                var emailTab = [];
                for(var i = 0; i < $scope.dd.shareInfo.emailList.length; i++){
                    emailTab.push($scope.dd.shareInfo.emailList[i].text);
                }
                return emailTab;
            };

            $scope.sendByMail = function(){
                if($scope.dd.shareInfo.emailList && $scope.dd.shareInfo.object && $scope.dd.currentPeriod.beginMomentDay && $scope.dd.currentPeriod.endMomentDay){

                    var emailTab = $scope.getSendMail();

                    DashboardSrv.export(
                        $scope.dd.selectedDashboardView.id,
                        $scope.dd.shareInfo.object,
                        $scope.dd.shareInfo.message,
                        $scope.dd.currentPeriod.beginMomentDay.format("YYYYMMDD"),
                        $scope.dd.currentPeriod.endMomentDay.format("YYYYMMDD"),
                        emailTab,
                        $scope.succesSendEmail,
                        $scope.failureSendEmail);
                }
                else{
                    $scope.updateError();
                }
            };

            $scope.updateErrorEmail = function(){
                $scope.dd.shareInfo.displayEmptyEmail = false;

                if(!$scope.dd.shareInfo.emailList || $scope.dd.shareInfo.emailList.length == 0){
                    $scope.dd.shareInfo.displayEmptyEmail = true;
                }
            };

            $scope.updateErrorObject = function(){
                $scope.dd.shareInfo.displayEmptyObject = false;

                if(!$scope.dd.shareInfo.object || $scope.dd.shareInfo.object == ""){
                    $scope.dd.shareInfo.displayEmptyObject = true;
                }
            };

            $scope.updateErrorSurname = function(){
                $scope.dd.shareInfo.displayEmptySurname = false;

                if(!$scope.dd.shareInfo.surname || $scope.dd.shareInfo.surname == ""){
                    $scope.dd.shareInfo.displayEmptySurname = true;
                }
            };

            $scope.updateError = function(){
                $scope.dd.shareInfo.displayEmptyEmail = false;
                $scope.dd.shareInfo.displayEmptyObject = false;
                $scope.dd.shareInfo.displayEmptySurname = false;

                if(!$scope.dd.shareInfo.emailList || $scope.dd.shareInfo.emailList == ""){
                    $scope.dd.shareInfo.displayEmptyEmail = true;
                }
                if(!$scope.dd.shareInfo.object || $scope.dd.shareInfo.object == ""){
                    $scope.dd.shareInfo.displayEmptyObject = true;
                }
                if(!$scope.dd.shareInfo.surname || $scope.dd.shareInfo.surname == ""){
                    $scope.dd.shareInfo.displayEmptySurname = true;
                }
            };

            $scope.canSendDashboard = function(){
                var canSendDashboard = true;

                if(!$scope.dd.shareInfo.emailList || $scope.dd.shareInfo.emailList.length == 0){
                    canSendDashboard = false;
                }
                if(!$scope.dd.shareInfo.object || $scope.dd.shareInfo.object == ""){
                    canSendDashboard = false;
                }
                if($scope.dd.shareInfo.periodic) {
                    if (!$scope.dd.shareInfo.surname || $scope.dd.shareInfo.surname == "") {
                        canSendDashboard = false;
                    }
                }
                return canSendDashboard;
            };

            $scope.addScheduler = function(){
                var dashboardSchedulerView =  new DashboardSchedulerView();
                dashboardSchedulerView.type = $scope.dd.shareInfo.type.id;
                dashboardSchedulerView.object = $scope.dd.shareInfo.object;
                dashboardSchedulerView.message = $scope.dd.shareInfo.message;
                dashboardSchedulerView.sendTo = $scope.dd.shareInfo.emailList;
                dashboardSchedulerView.dashboardId = $scope.dd.selectedDashboardView.id;
                dashboardSchedulerView.surname = $scope.dd.shareInfo.surname;

                $scope.dd.selectedDashboardView.dashboardSchedulersView.push(dashboardSchedulerView);
                dashboardSchedulerView.updateModel($scope.succesSendPeriodicEmail, $scope.failureSendEmail);

            };

            $scope.removeScheduler = function(dashboardSchedulerView){
                $scope.dd.selectedDashboardView.removeDashboardScheduler(dashboardSchedulerView);

                DashboardSchedulerSrv.remove(dashboardSchedulerView.getModel());
            };

            $scope.onGenderFilterClick = function(genderFilter){
                let indexGenderFilter = $scope.dd.additionalFilters.indexOf(genderFilter);
                if(indexGenderFilter == -1) {
                    $scope.dd.additionalFilters.push(genderFilter);
                }
                else{
                    $scope.dd.additionalFilters.splice(indexGenderFilter, 1);
                }
                $scope.reloadReportsDataSource();
            };


            $scope.redirectToPlanningIfStatisticsDisabled = function () {
                if ($scope.ad.domain === Constants.APP_DOMAIN.statistics) {
                    if (!$scope.ad.addons.sub.statisticsAccess) {
                        $scope.goToDomain(Constants.APP_DOMAIN.planningPos);
                    }
                }
            };

            $scope.$on('$destroy', function () {
                Timers.cancel(timers);
            });
        }
    ]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/StatisticsCtrl.js